import {DataInfoWindow} from '@/map/components/DataInfoWindow';

interface IProps {
  onClose(): void;
}

const CONTENT = [
  {
    list: [
      {
        desc: '카드사의 매출 데이터를 기반으로 전체 개인사업장의 월 매출액을 분석한 추정치입니다. 실제 홀 매출 정보와 차이가 있을 수 있습니다.',
      },
    ],
  },
  {
    title: '활용 팁',
    list: [
      {
        title: '선택 지역 총 매출액',
        desc: '분석 지역의 전체 카드 매출액을 확인하여 해당 지역의 전체 시장 규모를 확인할 수 있습니다.',
      },
      {
        title: '총 매출액',
        desc: '분석 지역 내 선택 업종의 시장 규모를 파악할 수 있습니다. 타 지역과 비교하여 시장 활성화 여부를 비교 분석할 수 있습니다.',
      },
      {
        title: '매장당 월평균 매출액',
        desc: '분석 지역 내 선택 업종을 신규 개점할 경우 어느 정도의 매출을 기대할 수 있는지 파악할 수 있습니다.',
      },
      {
        title: '총 매장수',
        desc: '분석 지역 내 선택 업종의 경쟁 강도를 확인할 수 있습니다.',
      },
      {
        title: '매장당 월평균 매출액 전월대비 증감률',
        desc: '매출 증감 추이를 통해 선택 업종의 계절적 변동이나 특정 이벤트의 영향을 확인할 수 있습니다.',
      },
    ],
  },
];

export const InfoWindow = ({onClose}: IProps) => {
  return (
    <DataInfoWindow
      title="홀 매출 분석 참고"
      content={CONTENT}
      onClose={onClose}
    />
  );
};
